import styled from "styled-components";

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100%;
  padding: 3rem 1.5rem;
  gap: 1.5rem;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 960px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  color: #111827;
`;

export const Subtitle = styled.p`
  margin: 0.5rem 0 0;
  font-size: 0.95rem;
  color: #4B5563;
`;

export const Banner = styled.div<{ $variant: "success" | "neutral" }>`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.875rem 1.25rem;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 500;
  background: ${(props) => (props.$variant === "success" ? "#ECFDF5" : "#F8FAFC")};
  border: 1px solid ${(props) => (props.$variant === "success" ? "#A7F3D0" : "#E2E8F0")};
  color: ${(props) => (props.$variant === "success" ? "#065F46" : "#475569")};

  svg {
    flex-shrink: 0;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ContinueButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.75rem;
  background: #001D30;
  color: #FFFFFF;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: #002C4A;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const BackLink = styled.button`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0;
  background: none;
  border: none;
  font-size: 0.85rem;
  color: #64748B;
  cursor: pointer;

  &:hover {
    color: #3B82F6;
  }
`;
